import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgProfilComponent } from './svg-profil.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SvgProfilComponent],
  exports: [SvgProfilComponent]
})
export class SvgProfilModule { }
